// extracted by mini-css-extract-plugin
export var divider = "_pi-0";
export var systemMessage = "_pi-1";
export var systemMessageWrapper = "_pi-2";